import React, { useState } from 'react';
import { User } from 'lucide-react';

const ProfilePicture = ({ url, size = 'md', alt = 'Profile picture', className = '' }) => {
  const [imageError, setImageError] = useState(false);
  
  // Map size string to actual pixel values
  const sizeMap = {
    'xs': { container: 'h-8 w-8', icon: 'h-4 w-4' },
    'sm': { container: 'h-10 w-10', icon: 'h-5 w-5' },
    'md': { container: 'h-16 w-16', icon: 'h-8 w-8' },
    'lg': { container: 'h-24 w-24', icon: 'h-12 w-12' },
    'xl': { container: 'h-32 w-32', icon: 'h-16 w-16' }
  };
  
  const { container, icon } = sizeMap[size] || sizeMap.md;

  // Helper function to ensure URL is properly formatted
  const getImageUrl = (imgUrl) => {
    if (!imgUrl) return null;
    
    // If it's already an absolute URL, return it
    if (imgUrl.startsWith('http')) {
      return imgUrl;
    }
    
    // For relative URLs, prepend the API URL
    return `${process.env.REACT_APP_API_URL}${imgUrl}`;
  };
  
  // Show the user icon as fallback if no URL or if image failed to load
  if (!url || imageError) {
    return (
      <div className={`flex-shrink-0 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center ${container} ${className}`}>
        <User className={`text-gray-500 dark:text-gray-400 ${icon}`} />
      </div>
    );
  }
  
  // Get the properly formatted image URL
  const imageUrl = getImageUrl(url);
  
  return (
    <div className={`flex-shrink-0 ${container} ${className}`}>
      <img 
        src={imageUrl} 
        alt={alt} 
        className="h-full w-full rounded-full object-cover"
        onError={() => setImageError(true)}
      />
    </div>
  );
};

export default ProfilePicture;